import { FormattedMessage } from 'react-intl';
import { GraphQLNotConnectedBoundary } from '../../../GraphQL/Fallback';
import { useUserWorkspaceAccessSummary } from './accessSummary/getUserWorkspaceAccessSummary';

export const WorkspaceFooter = ({
  hasRestrictedWorkspace,
  clientName,
}: {
  hasRestrictedWorkspace: boolean;
  clientName: string;
}) => (
  <>
    {hasRestrictedWorkspace ? (
      <GraphQLNotConnectedBoundary
        fallback={
          <RestrictedWorkspaceFooterComponent
            clientName={clientName}
            displayName="???"
          />
        }
      >
        <RestrictedWorkspaceFooter clientName={clientName} />
      </GraphQLNotConnectedBoundary>
    ) : (
      <FormattedMessage
        id="trello.permissions.footer.unrestrictedWorkspace"
        defaultMessage="Additionally, {appName} will have access to any boards and Workspaces you gain access to in the future"
        description="Disclaimer detailing that not only will the app have access to the current boards and workspaces but also any new ones that the user is added to"
        values={{
          appName: <strong>{clientName}</strong>,
        }}
      />
    )}
  </>
);

function RestrictedWorkspaceFooter({ clientName }: { clientName: string }) {
  const { displayName } = useUserWorkspaceAccessSummary();
  return (
    <RestrictedWorkspaceFooterComponent
      clientName={clientName}
      displayName={displayName}
    />
  );
}

const RestrictedWorkspaceFooterComponent = ({
  clientName,
  displayName,
}: {
  clientName: string;
  displayName: string;
}) => (
  <FormattedMessage
    id="trello.permissions.footer.restrictedWorkspace"
    defaultMessage="Additionally, {appName} will have access to any new boards added to {workspace} in the future"
    description="Disclaimer detailing that not only will the app have access to the current boards in the workspaces but also any new ones that the user is added to in the specific workspace"
    values={{
      appName: <strong>{clientName}</strong>,
      workspace: <strong>{displayName}</strong>,
    }}
  />
);
